import Vue from 'vue';
import VueRouter from 'vue-router';
import granted from '@/shared/granted';
import vuetify from '@/shared/vuetify';

import storeNotifier, {NotifyInterface} from '@/stores/modules/notifier';

import Login from '@/views/Login.vue';
import ResetPasswordConfirm from '@/views/ResetPasswordConfirm.vue';

import transporteur from './transporteur';
import contact from './contact';
import user from './user';
import fournisseur from './fournisseur';
import client from './client'
import essenceAchat from './essenceAchat'
import livraison from './livraison'
import vente from './vente'
import achat from './achat'
import token from './token';
import boisType from './boisType';
import longueursVente from './longueursVente';
import longueursAchat from './longueursAchat';
import approvisionnement from './approvisionnement';
import commande from './commande';
import pile from './pile';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'login',
		meta: { loginPage: true },
		component: Login,
	},
	{
		path: '/reset-password-confirm/:email',
		name: 'reset_password_confirm',
		meta: { loginPage: true },
		component: ResetPasswordConfirm,
	},
	{
		path: '/accueil',
		name: 'home',
		meta: { granted: [] },
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Home.vue')
	},
	{
		path: '/tableau-achats',
		name: 'tableauAchats',
		meta: { granted: [] },
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/TableauDeBordAchat.vue')
	},
	{
		path: '/tableau-ventes',
		name: 'tableauVentes',
		meta: { granted: [] },
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/TableauDeBordVente.vue')
	},
	{
		path: '/planning',
		name: 'planning',
		meta: { granted: [] },
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Planning.vue')
	},
	...transporteur,
	...contact,
	...user,
	...fournisseur,
	...client,
	...essenceAchat,
	...livraison,
	...vente,
	...achat,
	...token,
	...boisType,
	...longueursVente,
	...longueursAchat,
	...approvisionnement,
	...commande,
	...pile,
	{
		path: '*',
		redirect: { name: 'home' },
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
});

router.beforeEach((to: any, from: any, next: Function) => {
	if (granted.firstPageLoaded() && !granted.checkRouteGranted(to)) {
		storeNotifier.dispatch('notify', {
			type: 'error',
			message: 'Accès refusé'
		} as NotifyInterface);
		if (granted.isConnected()) {
			next({ name: 'home'});
			return;
		}
		next({ name: 'login'});
		return;
	}
	next();
});
export default router
